const messages = {
  error_unavailable: 'La página web no está disponible actualmente',
  error_not_found: 'Página no encontrada'
}

export default {
  messages
}
